/**
 * 결제 관련 타입 정의
 */

// 결제 상태
export enum PaymentStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED'
}

// 결제 수단 타입
export enum PaymentMethodType {
  CARD = 'CARD',
  BANK_TRANSFER = 'BANK_TRANSFER',
  VIRTUAL_ACCOUNT = 'VIRTUAL_ACCOUNT',
  PHONE = 'PHONE',
  KAKAO_PAY = 'KAKAO_PAY',
  NAVER_PAY = 'NAVER_PAY',
  TOSS_PAY = 'TOSS_PAY'
}

// 빌링 주기
export enum BillingCycle {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
  CUSTOM = 'CUSTOM'
}

// 구독 상태
export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}

// 상품 정보
export interface Product {
  id: string;
  name: string;
  description?: string;
  price: number;
  discountPrice?: number;
  currency: string;
  category: string;
  features?: string[];
  isPopular?: boolean;
  isRecommended?: boolean;
  billingCycle?: BillingCycle;
  duration?: number;
  popular?: boolean;
}

// 결제 수단
export interface PaymentMethod {
  id: string;
  type: PaymentMethodType;
  name: string;
  cardNumber?: string; // 마스킹된 카드 번호
  cardCompany?: string;
  isDefault: boolean;
  isExpired: boolean;
  expiresAt?: string;
}

// 빌링키
export interface BillingKey {
  id: string;
  provider: string;
  cardCompany: string;
  cardNumber: string; // 마스킹된 번호
  cardType: string;
  isDefault: boolean;
  status: string;
  createdAt: string;
}

// 결제 요청
export interface PaymentRequest {
  productId: string;
  amount: number;
  paymentMethodId?: string;
  paymentMethodType: PaymentMethodType;
  customer: {
    name: string;
    email: string;
    phone: string;
  };
  metadata?: Record<string, any>;
}

// 결제 응답
export interface PaymentResponse {
  paymentId: string;
  status: PaymentStatus;
  amount: number;
  paymentKey?: string;
  checkoutUrl?: string;
  receiptUrl?: string;
  paidAt?: string;
  metadata?: Record<string, any>;
}

// 결제 내역
export interface Payment {
  id: string;
  orderId: string;
  productName: string;
  amount: number;
  status: PaymentStatus;
  paymentMethod: string;
  paymentMethodType: PaymentMethodType;
  paidAt?: string;
  cancelledAt?: string;
  receiptUrl?: string;
  metadata?: Record<string, any>;
}

// 구독 정보
export interface Subscription {
  id: string;
  name: string;
  description?: string;
  amount: number;
  billingCycle: BillingCycle;
  status: SubscriptionStatus;
  nextBillingDate?: string;
  lastBillingDate?: string;
  billingKeyId: string;
  failedCount: number;
  createdAt: string;
  cancelledAt?: string;
}

// 약관 정보
export interface Terms {
  id: string;
  title: string;
  content: string;
  version: string;
  isRequired: boolean;
  effectiveDate: string;
}

// 약관 동의
export interface TermsAgreement {
  termsId: string;
  isAgreed: boolean;
  agreedAt?: string;
}